import {Component} from '@angular/core';
import {DashboardService} from '../../../../bonding_shared/services/dashboard.service';
import {ChartRestLoader} from '../chart-rest-loader';
import {BusinessPropertiesService} from '../../../../bonding_shared/services/business-properties.service';
import {VMap} from './vmap';
import {ApplicationModule} from '../../../../bonding_shared/model/dictionary-ids';
import {SettingsService} from '../../../../bonding_shared/services';
import {StringUtils} from '../../../../bonding_shared/utils';

@Component({
  selector: 'bonding-map',
  template: `<div id="{{mapType}}" style="height: 400px;"></div>`
})
export class BondingMapComponent extends VMap implements ChartRestLoader {

  constructor(public service: DashboardService, public businessProps: BusinessPropertiesService, public settingsService: SettingsService) {
    super(service, businessProps, settingsService);
    this.applicationModuleId = ApplicationModule.BONDING;
  }

  onLabelShowFunction(countryData: BondingCountryPerformance, currency: string): (event: any, label: any, code: string) => void {
    function f(event: any, label: any, code: string): void {
      label.html(
        '<h2>' + ((label[0].firstChild.textContent) ? label[0].firstChild.textContent : label[0].innerHTML) + '</h2>' +
        '<p>Bonds value: ' + StringUtils.formatNumber(countryData[code] && countryData[code].bondsValue ? countryData[code].bondsValue : 0) + '&nbsp;' + currency + '</p>' +
        '<p>Bonds count: ' + (countryData[code] && countryData[code].bondsNumber ? countryData[code].bondsNumber : 0) + '</p>' +
        '<p>Contracts count: ' + (countryData[code] && countryData[code].contractsNumber ? countryData[code].contractsNumber : 0) + '</p>'
      );
    }
    return f;
  }

  saveRestResult(result: any) {
    const code: string = result.country.code.toLowerCase();
    this.countryPerformance[code] = {
      bondsValue: result.bondsValue,
      contractsNumber: result.contractsNumber,
      bondsNumber: result.bondsNumber
    };
  }

  getPerformanceValues (bondingCountryPerformance: BondingCountryPerformance): {[key: string]: number} {
    const values: {[key: string]: number} = {};
    for (const k in bondingCountryPerformance) {
      if (k) {
        values[k] = bondingCountryPerformance[k].bondsValue;
      }
    }
    return values;
  }
}

export class BondingCountryPerformance {
  [code: string]: {
    bondsValue: number;
    bondsNumber: number;
    contractsNumber: number;
  };
}
